import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {memoize} from 'decko';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';

import {DataChangesObserver, TitleService} from '@common-lib';
import {CategoriesService, ConfigurationService, ProductsService, SubcategoriesService} from '../../pages-services';
import {ConfigurationBaseComponent} from '../configuration-base/configuration-base.component';

@Component({
    selector: 'app-configuration-categories',
    templateUrl: './configuration-categories.component.html',
    styleUrls: ['../configuration-base/configuration-base.component.scss', '../configuration-categories/configuration-categories.component.scss'],
})

export class ConfigurationCategoriesComponent extends ConfigurationBaseComponent implements OnInit {
    resource = 'category';

    categories = [];
    subcategories = [];
    products = [];
    views = [];

    subcategoryById = [];
    productsById = [];
    viewById = [];

    constructor(
        protected title: TitleService,
        protected route: ActivatedRoute,
        protected toasterService: ToasterService,
        protected dataChanges: DataChangesObserver,
        protected translateService: TranslateService,
        protected configurationService: ConfigurationService,
        private productsService: ProductsService,
        private categoriesService: CategoriesService,
        private subcategoriesService: SubcategoriesService
    ) {
        super(title, route, toasterService, dataChanges, translateService, configurationService);
    }

    ngOnInit() {
        this.productsService.getList(this.selectedLocale).subscribe(({products}) => {
            products.forEach(product => {
                this.productsById[product.id] = product.title;
            });
            this.products = products;
        });

        this.subcategoriesService.getList(this.selectedLocale).subscribe(({subcategories}) => {
            subcategories.forEach(subcategory => {
                const {name, productId, id} = subcategory;
                this.subcategoryById[id] = {name, productId};
            });
            this.subcategories = subcategories;
        });

        this.configurationService.getList('views', this.selectedLocale).subscribe(({result}) => {
            result.views.forEach(view => {
                const {name, id} = view;
                this.viewById[id] = {name};
            });
            this.views = result.views;
        });

        this.loadItems();
    }

    protected loadItems(): Promise<Object> {
        return new Promise((resolve, reject) => {
            this.categoriesService.getList(this.selectedLocale).subscribe(({categories}) => {
                this.state.items = this.createChangesObservation(categories);
                resolve(this.state.items);
            }, error => reject(error));
        });
    }

    @memoize()
    getViewsDropdownList(categoryId) {
        return this.views.filter(item => item.categoryId === categoryId || !item.categoryId);
    }

    @memoize()
    getSubcategoriesDropdownList(categoryId) {
        return this.subcategories.filter(item => item.categoryId === categoryId || !item.categoryId);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/configuration-categories/configuration-categories.component.ts